<div class="soft-ds-drcp-trigger">
  <soft-ds-prev-curr-next-navigation
    [bordered]="false"
    [size]="navSize()"
    [disabled]="disabled()"
    [style.--btn-size]="navBtnSizePx()"
    (previous)="onPrev()"
    (today)="onToday()"
    (next)="onNext()"
  />

  <button
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    type="button"
    class="soft-ds-drcp-trigger-button ds-body-2"
    [class.is-label]="!compact()"
    [class.is-icon]="compact()"
    [disabled]="disabled()"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-label]="compact() ? triggerLabel() : null"
    aria-haspopup="dialog"
    (click)="onLabelClick()"
  >
    @if (compact()) {
      <soft-ds-icon name="fa-regular fa-calendar-range" size="sm" aria-hidden="true" />
    } @else {
      {{ triggerLabel() }}
    }
  </button>
</div>

<soft-ds-overlay
  [originElement]="origin"
  [(open)]="isOpen"
  [dividers]="false"
  [content]="popoverBody"
/>

<ng-template #popoverBody>
  <soft-ds-date-range-comparison-picker-popover
    [initialValue]="value()"
    [fiscalYearStart]="fiscalYearStart()"
    (apply)="onApply($event)"
    (cancelled)="onCancel()"
  />
</ng-template>
